"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKETING_COLORS = exports.MARKETING_COLORS_CORE = exports.MARKETING_COLORS_HOLIDAY = exports.MARKETING_COLORS_BRAND = void 0;
exports.MARKETING_COLORS_BRAND = {
    "midnight": { "code": "#2f3a53", "mode": { "dark": true, "standard": false } },
    "warmWhite": { "code": "#f6f6ec", "mode": { "dark": false, "standard": true } },
    "white": { "code": "#ffffff", "mode": { "dark": false, "standard": true } },
};
exports.MARKETING_COLORS_HOLIDAY = {
    "holiday": { "code": "#9a0202", "mode": { "dark": true, "standard": false } },
    "green2": { "code": "#06462e", "mode": { "dark": true, "standard": false } },
    "green1": { "code": "#50af60", "mode": { "dark": false, "standard": true } },
    "red1": { "code": "#8b0d13", "mode": { "dark": true, "standard": false } },
    "red2": { "code": "#8b0d13", "mode": { "dark": true, "standard": false } },
    "beige1": { "code": "#ede3cf", "mode": { "dark": false, "standard": true } }
};
exports.MARKETING_COLORS_CORE = {
    "rum": { "code": "#c94b2f", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "talavera": { "code": "#2b3b55", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "atlantic": { "code": "#16618c", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "kingfisher": { "code": "#017eb4", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "rio": { "code": "#99d3f3", "mode": { "dark": false, "standard": true }, "deprecated": true },
    "caspian": { "code": "#204949", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "celtic": { "code": "#046240", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "emerald": { "code": "#0a806b", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "mediumGreen": { "code": "#318643", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "opal": { "code": "#c0e6df", "mode": { "dark": false, "standard": true }, "deprecated": true },
    "black900": { "code": "#000000", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "graphite": { "code": "#313131", "mode": { "dark": true, "standard": false }, "deprecated": true },
    "mediumGrey": { "code": "#dfdfdf", "mode": { "dark": false, "standard": true }, "deprecated": true },
    "platinum": { "code": "#efefef", "mode": { "dark": false, "standard": true }, "deprecated": true }
};
exports.MARKETING_COLORS = __assign(__assign(__assign({}, exports.MARKETING_COLORS_CORE), exports.MARKETING_COLORS_BRAND), exports.MARKETING_COLORS_HOLIDAY);
